import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-franchising-recommender]')) return;
  addEventListeners();
}

function addEventListeners() {
  franchisingDatalayer();
}

function franchisingDatalayer() {
  const itemIdTitle = {
    start: 'Paso 1 Selección',
    dodo2: 'Paso 2 Qué desea',
    codo2: 'Paso 2 Experiencia',
    codo2exp: 'Paso 2 Alta dedicación',
    codo3: 'Paso 3 Dispones de capital',
    codo4: 'Capital disponible',
    step5: '',
    dodo3rentstation: 'Paso 3 Alquilar EESS',
    dodo3rentspace: 'Paso 3 Alquilar terreno',
    dodo3franchising: 'Paso 3 Franquiciar con Moeve',
    dodo3sellstation: 'Paso 3 Vender estación',
    dodo3sellspace: 'Paso 3 Vender terreno',
  };

  $$('[data-au-franchising-recommender] [data-au-recommender-hide]').forEach((option) => {
    const optionHide = option.dataset.auRecommenderHide,
      itemIdFirstHalf = itemIdTitle[optionHide],
      cardText = option.querySelector('p'),
      itemIdSecondHalf = cardText ? cardText.textContent : option.querySelector(':not([data-au-icon]').textContent,
      content_type = cardText ? 'clickCard' : option.classList.contains('au-button') ? 'clickBoton' : 'clickEnlace';
    const item_id =
      itemIdFirstHalf === ''
        ? removeAccentMarkAndUppercase(itemIdFirstHalf)
        : removeAccentMarkAndUppercase(`${itemIdFirstHalf}_${itemIdSecondHalf}`);
    option.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'navigation',
        content_type,
        item_id,
      });
    });
  });

  $$('[data-au-franchising-recommender] [data-au-recommender-success-button]').forEach((button) => {
    button.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'generate_lead',
        content_type: 'download',
        item_id: 'download_franquicias',
      });
    });
  });

  $$('[data-au-franchising-recommender] [data-au-recommender-submit-button]').forEach((button) => {
    button.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'generate_lead',
        content_type: 'lead_generation',
        item_id: 'lead_generation_franquicias',
      });
    });
  });
}

export default { init };
